import React from "react";

const FormRequestStatus = ({ rejected, completed, engaged }) => {

  if (rejected) {
    return <Status text="Rejected" bgColor="bg-red-600" />;
  }

  if (completed) {
    return <Status text="Completed" bgColor="bg-red-600" />;
  }

  if (engaged) {
    return <Status text="Engaged" bgColor="bg-gray-600" />;
  }
  return <Status text="New" bgColor="bg-blue-500" />;
};

export default FormRequestStatus;

const Status = ({ text, bgColor }) => {
  return (
    <div className={`rounded-full px-2 py-1 text-xs  text-white ${bgColor}`}>
      {text}
    </div>
  );
};
